// @ts-nocheck
import ActionTypes from "../constants/actions";
import { Map, Record, Set } from "immutable";
import _ from "lodash";
import { mergeArraytoSet, addToSet, updateSet } from "../utils/redux";

export const RegistrationTeam = Record({
  _id: "",
  division: "",
  league: "",
  team: {},
  season: "",
  user: "",
  status: "",
  teamName: "",
  completed: "",
  startDate: "",
  teamManager1: {},
  teamManager2: {},
  created: "",
  players: []
});

export const defaultState = { loading: false, error: "", result: new Set([]) };

export default ({ result, loading, error } = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.SET_REGISTRATION_REQUEST:
      return { loading: true, error: "", result: result };
    case ActionTypes.SET_TEAM_REGISTRATION_BY_LEAGUE:
      return {
        loading: false,
        error: "",
        result: mergeArraytoSet(action.registrationTeams, result, RegistrationTeam)
      };
    case ActionTypes.UPDATE_TEAM_REGISTRATIONS:
    case ActionTypes.SAVE_TEAM_REGISTRATION_SUCCESS:
      console.log("SAVE_TEAM_REGISTRATION_SUCCESS: ", action.teamRegistration);
      return {
        loading: false,
        error: "",
        result: updateSet(action.teamRegistration, result, RegistrationTeam)
      };
    case ActionTypes.SET_TEAM_REGISTRATIONS:
      console.log("SET_TEAM_REGISTRATION: ", action.teamRegistration);
      return {
        loading: false,
        error: "",
        result: mergeArraytoSet(action.registrationTeams, result, RegistrationTeam)
      };
    //   return { loading: false, error: "", result: mergeArraytoSet(action.registration, result, Registration) };
    // return { loading: false, error: "", result: action.registrationTeams };
    default:
      return { loading, error, result };
  }
};
